import { Link } from 'react-router-dom';
import { Leaf, Heart } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-leaf-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <Leaf className="text-leaf-400" size={28} />
              <span className="font-heading text-2xl">Leafscape</span>
            </div>
            <p className="text-leaf-200 text-sm max-w-md">
              Empowering young minds to become environmental champions through
              fun, engaging activities throughout the year.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg mb-4 text-leaf-300">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-leaf-200 hover:text-white transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-leaf-200 hover:text-white transition-colors text-sm">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-leaf-200 hover:text-white transition-colors text-sm">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-4 text-leaf-300">Contact</h4>
            <ul className="space-y-2 text-sm text-leaf-200">
              <li>info@leafscape.co.ke</li>
              <li>Nairobi, Kenya</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-leaf-700 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-leaf-300 text-sm">
            &copy; {currentYear} Leafscape. All rights reserved.
          </p>
          <p className="text-leaf-300 text-sm flex items-center gap-1">
            Made with <Heart size={14} className="text-red-400 fill-current" /> for the planet
          </p>
        </div>
      </div>
    </footer>
  );
}
